import { useEffect, useState } from "react";
import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Panel, useOps } from "./ui";
import { Discovery } from "./Discovery";

const LABELS = { players_today: "Players today", players_week: "Players this week", players_all: "Players all-time",
  reached_poster: "Reached poster", opted_out: "Opted out", flagged: "Flagged", pending_deletions: "Pending deletions" };

export default function Overview() {
  const { api } = useOps();
  const [data, setData] = useState(null);
  const [incTest, setIncTest] = useState(false);
  useEffect(() => { api.get("/overview", { params: { include_test: incTest } }).then((r) => setData(r.data)); }, [api, incTest]);
  if (!data) return null;
  const drop = data.largest_drop;
  return (
    <div className="space-y-3">
      <label className="flex items-center gap-2 text-xs text-slate-400">
        <input type="checkbox" data-testid="overview-include-test" checked={incTest} onChange={(e) => setIncTest(e.target.checked)} /> include test players
      </label>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-2">
        {Object.entries(data.top).map(([k, v]) => (
          <div key={k} data-testid={`admin-stat-${k}`} className="rounded border border-[#243144] bg-[#131a26] px-3 py-2">
            <div className="text-[10px] uppercase tracking-wider text-slate-500">{LABELS[k] || k}</div>
            <div className="mono text-2xl text-slate-100">{v}</div>
          </div>
        ))}
      </div>
      <Panel title="Funnel" testid="admin-funnel-chart" actions={drop?.stage && <span data-testid="admin-funnel-largest-drop" className="text-[11px] text-red-400">largest drop → {drop.stage} (−{drop.drop})</span>}>
        <div className="h-72">
          <ResponsiveContainer>
            <BarChart data={data.funnel} margin={{ left: -20, right: 8 }}>
              <XAxis dataKey="stage" tick={{ fontSize: 10, fill: "#94a3b8" }} interval={0} angle={-30} textAnchor="end" height={60} />
              <YAxis allowDecimals={false} tick={{ fontSize: 10, fill: "#94a3b8" }} />
              <Tooltip contentStyle={{ background: "#131a26", border: "1px solid #243144", fontSize: 12 }} cursor={{ fill: "#1a2332" }} />
              <Bar dataKey="count">
                {data.funnel.map((f, i) => <Cell key={f.stage} fill={i === drop?.index ? "#ef4444" : "#38bdf8"} />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Panel>
      <Discovery data={data.discovery} />
    </div>
  );
}
